import { flow } from 'lodash';
import { takeLatest, call, put, delay } from 'redux-saga/effects';

import fetch from '@giro/shared-utils/fetch.util';

import auth from '@giro/shared-store/auth';
import toaster from '@giro/shared-store/toaster';

import postApisAccountsService from '@giro/shared-services/pdv/postApiAccounts.service';

import currentStore from '.';

function* handleFetchStart({ payload }: any) {
  const toasterShow = flow(toaster.action.show, put);

  const [success, body] = yield call(async (payload) => {
    return fetch(`linkstates/${payload.code}/connect`, {
      method: 'POST',
      ms: 'PDV',
    });
  }, payload);

  if (!success || !body?.valid) {
    yield toasterShow({
      message: 'Código inválido',
      variant: 'error',
    });

    return yield put(currentStore.action.fetchError(body));
  }

  const { token } = body;

  yield put(auth.action.setToken(token));

  return yield put(currentStore.action.fetchEnd(body));
}

function* watch() {
  yield takeLatest(
    currentStore.constant.ACTION_TYPES.FETCH.START,
    handleFetchStart
  );
}

export default {
  watch,
};
